import React, { useContext } from "react";
import { languageContext } from "../../../../config/language";

// types
import { Origin } from "../../../../types/origins";
import { Leader } from "../../../../types/leaders";
import { Supervisor } from "../../../../types/supervisors";
import { Seller } from "../../../../types/sellers";
import { State } from "../../../../types/states";
import { Channel } from "../../../../types/channels";
import { Client } from "../../../../types/clients";

// components
import MultiSelect from "../../../Common/MultiSelect";

// styled components
import { ExternalFilterContainer, FilterButton } from "../Filters.styles";
import {OperationType} from "../../../../types/operationTypes";

interface Props {
  // Business Filters
  idSourceFilter: string;
  setIdSourceFilter: (value: string) => void;
  originsSelected: Origin[];
  leadersSelected: any[];
  supervisorsSelected: any[];
  sellersSelected: any[];
  statesSelected: State[];
  channelsSelected: Channel[];
  clientsSelected: Client[];
  operationTypesSelected: OperationType[];
  setOriginsSelected: (param: Origin[]) => void;
  setLeadersSelected: (param: any[]) => void;
  setSupervisorsSelected: (param: any[]) => void;
  setSellersSelected: (param: any[]) => void;
  setStatesSelected: (param: State[]) => void;
  setChannelsSelected: (param: Channel[]) => void;
  setClientsSelected: (param: Client[]) => void;
  setOperationTypesSelected: (param: OperationType[]) => void;
  sendFilters: () => void;
  resetFilters: () => void;

  // redux
  origins: Origin[];
  fetchingOriginsList: boolean;
  leaders: Leader[];
  fetchingLeadersList: boolean;
  supervisors: Supervisor[];
  fetchingSupervisorsList: boolean;
  sellers: Seller[];
  fetchingSellersList: boolean;
  states: State[];
  fetchingStatesList: boolean;
  channels: Channel[];
  fetchingChannelsList: boolean;
  clients: Client[];
  fetchingClientsList: boolean;
  operationTypes: OperationType[];
  fetchingOperationTypesList: boolean;
}

export default (props: Props) => {
  const { languageContext: lang } = useContext(languageContext);

  const filters_first_row = [
    {
      filter_code: "origin",
      placeholder: "Origen",
      optionList: props.origins,
      dataItemKey: "shortDescription",
      optionName: "description",
      inputId: "input_origins",
      values: props.originsSelected,
      handleChange: props.setOriginsSelected,
      disabled: Boolean(
        props.fetchingOriginsList
      ),
      loading: props.fetchingOriginsList,
      dataCy: 'selector-origin',
    },
    // todo pilas comments
    {
      filter_code: "leader",
      placeholder: lang.leader,
      optionList: props.leaders.sort((a, b) => parseInt(a.leaderId) - parseInt(b.leaderId)),
      dataItemKey: "leaderId",
      optionName: "joined",
      inputId: "input_leaders",
      values: props.leadersSelected,
      handleChange: props.setLeadersSelected,
      disabled: Boolean(
          props.fetchingLeadersList
      ),
      loading: props.fetchingLeadersList,
      dataCy: 'selector-leader',
    },
    {
      filter_code: "supervisor",
      placeholder: lang.supervisor,
      optionList: props.supervisors.sort((a, b) => parseInt(a.supervisorId) - parseInt(b.supervisorId)),
      dataItemKey: "supervisorId",
      optionName: "joined",
      inputId: "input_supervisors",
      values: props.supervisorsSelected,
      handleChange: props.setSupervisorsSelected,
      disabled: Boolean(
        props.fetchingSupervisorsList
      ),
      loading: props.fetchingSupervisorsList,
      dataCy: 'selector-supervisor',
    },
    {
      filter_code: "seller",
      placeholder: lang.seller,
      optionList: props.sellers.sort((a, b) => parseInt(a.sellerId) - parseInt(b.sellerId)),
      dataItemKey: "sellerId",
      optionName: "joined",
      inputId: "input_seller",
      values: props.sellersSelected,
      handleChange: props.setSellersSelected,
      disabled: Boolean(
        props.fetchingSellersList
      ),
      loading: props.fetchingSellersList,
      dataCy: 'selector-seller',
    },
  ];
  const filters_second_row = [
    {
      filter_code: "state",
      placeholder: 'Estado',
      optionList: props.states,
      dataItemKey: "state",
      optionName: "state",
      inputId: "input_state",
      values: props.statesSelected,
      handleChange: props.setStatesSelected,
      disabled: Boolean(
        props.fetchingStatesList
      ),
      loading: props.fetchingStatesList,
      dataCy: 'selector-state',
    },
    {
      filter_code: "channel",
      placeholder: 'Canales',
      optionList: props.channels,
      dataItemKey: "clientChannel",
      optionName: "clientChannel",
      inputId: "input_channel",
      values: props.channelsSelected,
      handleChange: props.setChannelsSelected,
      disabled: Boolean(
        props.fetchingChannelsList
      ),
      loading: props.fetchingChannelsList,
      dataCy: 'selector-channel',
    },
    {
      filter_code: "client",
      placeholder: 'Cliente',
      optionList: props.clients.sort((a, b) => parseInt(a.clientId) - parseInt(b.clientId)),
      dataItemKey: "clientId",
      optionName: "joined",
      inputId: "input_client",
      values: props.clientsSelected,
      handleChange: props.setClientsSelected,
      disabled: Boolean(
        props.fetchingClientsList
      ),
      loading: props.fetchingClientsList,
      dataCy: 'selector-client',
    },
    {
      filter_code: "operation_types",
      placeholder: 'Tipos de operacion',
      optionList: props.operationTypes.sort((a, b) => parseInt(a.axumOperationTypeCode) - parseInt(b.axumOperationTypeCode)),
      dataItemKey: "axumOperationTypeCode",
      optionName: "joined",
      inputId: "input_operation_types",
      values: props.operationTypesSelected,
      handleChange: props.setOperationTypesSelected,
      disabled: Boolean(
          props.fetchingOperationTypesList
      ),
      loading: props.fetchingOperationTypesList,
      dataCy: 'selector-operation-types',
    },
  ];

  return (
    <div>
      <div className="row">
        {filters_first_row.map((filter: any, filterKey: number) => (
          <ExternalFilterContainer
            className="col-md-3 col-md-3 col-sm-12"
            key={filterKey}
          >
            <MultiSelect {...filter} />
          </ExternalFilterContainer>
        ))}
      </div>
      <div className="row">
        {filters_second_row.map((filter: any, filterKey: number) => (
          <ExternalFilterContainer
            className="col-md-3 col-md-3 col-sm-12"
            key={filterKey}
          >
            <MultiSelect {...filter} />
          </ExternalFilterContainer>
        ))}
        <ExternalFilterContainer className="col-md-3 col-sm-12">
          <div className="k-textbox k-input k-input-md k-rounded-md k-input-solid" style={{ width: "100%" }}>
            <input
              id="input_id_source"
              type="text"
              placeholder="IdSource"
              value={props.idSourceFilter}
              onChange={e => props.setIdSourceFilter(e.target.value)}
              onKeyDown={e => (e.key === "Enter" ? props.sendFilters() : undefined)}
              data-cy="input-id-source"
              style={{ width: "100%" }}
            />
            <span className="k-input-icon k-icon k-i-search" />
          </div>
        </ExternalFilterContainer>
        <ExternalFilterContainer className="col-md-3 col-md-3 col-sm-12">
          <FilterButton
            type="button"
            className="btn btn-default btn-md"
            data-cy="ButtonFilter"
            onClick={props.sendFilters}
          >
            {lang.filter}
          </FilterButton>
          <FilterButton
              type="button"
              className="btn btn-default btn-md"
              data-cy="ButtonResetFilters"
              onClick={props.resetFilters}
          >
            {lang.resetFilters}
          </FilterButton>
        </ExternalFilterContainer>
      </div>
    </div>
  );
};
